module.exports = __webpack_public_path__ + "static/media/obx.58e55b66.png";